import "moment-timezone";
import React, { Component } from "react";
import { Link } from 'react-router-dom';


class TemplatesTable extends Component {
  constructor(props) {
    super(props);
    this.state = { items: props.items };
  }

  render() {
    const TemplatesTable = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <TemplatesTableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
            />
          ))}
        </tbody>
      );
    };

    const TemplatesTableHeader = props => {
      return (
        <thead className='dark'>
          <tr>
            <th>Template Key</th>
            <th>Subject</th>
            <th>From</th>
            <th>Description</th>
          </tr>
        </thead>
      );
    };

    const TemplatesTableItem = props => {
      const template = props.item
      return (
        <tr key={template.id}>
          <td data-label="Key"><Link to={`/m1/admin/templates/${template.id}`}>{template.key}</Link></td>
          <td data-label="Subject">{template.subject}</td>
          <td data-label="From">{template.from_name} &lt;{template.from_email}&gt;</td>
          <td data-label="Description">{template.description}</td>
        </tr>
      );
    };
    return (
      <div>
        <table
          className="table table-hover table-bordered stable-condensed responsive"
          style={{ width: "100%" }}
        >
          <TemplatesTableHeader />
          <TemplatesTable items={this.state.items} />
        </table>
      </div>
    );
  }
}

export default (TemplatesTable)